import * as React from "react";
import Helmet from "react-helmet";
import { connect } from "react-redux";
import { RouteProps } from "react-router-dom";

import { Wrap } from "../../components/Layout/Page";
import Loading from "../../components/Loading";
import {
  loadRules,
  addAction,
} from "../../redux/modules/action/actionCreators";
import { CreateAction } from "../../components/Action/CreateAction";

interface StateProps {
  appSetupComplete: boolean;
  isRulesLoading: boolean;
  isPending: boolean;
  rules: string[];
  sites: Insite.Site[];
  token?: string;
  userAccess?: Insite.API.User["access"];
  userGroups?: Insite.API.User["groups"];
  submitError: string;
  urlHistory: Insite.AppState["urlHistory"];
}

interface DispatchProps {
  requestRules: typeof loadRules;
  requestSave: typeof addAction;
}

interface OwnProps {
  requestRules?(): void;
  requestSave?(): void;
}

function mapStateToProps({
  betaAction,
  appSetup,
  userSites,
  betaSelections,
  urlHistory,
  auth,
}: Insite.AppState): StateProps {
  const sites = (betaSelections.selectedSites as string[]).map(
    (siteId) => userSites.sites[siteId]
  );

  return {
    appSetupComplete: appSetup.appSetupComplete,
    isRulesLoading: betaAction.isRulesLoading,
    isPending: betaAction.isPending,
    token: auth.user.token,
    userAccess: auth.user.access,
    userGroups: auth.user.groups,
    submitError: betaAction.submitError,
    rules: betaAction.rules,
    sites,
    urlHistory,
  };
}

interface State {
  assignees: Insite.Assignee[];
}

const mapDispatchToProps: DispatchProps = {
  requestRules: loadRules,
  requestSave: addAction,
};

type Props = OwnProps & StateProps & DispatchProps & RouteProps;
class CreateActionScene extends React.PureComponent<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      assignees: [],
    };
  }

  componentDidMount() {
    const { appSetupComplete, rules } = this.props;
    if (appSetupComplete && rules.length < 1) {
      this.props.requestRules();
    }
  }

  componentDidUpdate({ appSetupComplete }: Props) {
    const { isRulesLoading, rules } = this.props;

    if (
      !appSetupComplete &&
      this.props.appSetupComplete &&
      !isRulesLoading &&
      rules.length < 1
    ) {
      this.props.requestRules();
    }
  }

  render() {
    const {
      appSetupComplete,
      isRulesLoading,
      isPending,
      submitError,
      rules,
      sites,
      userAccess,
      userGroups,
      requestSave,
      urlHistory,
      token,
    } = this.props;

    if (!appSetupComplete || rules.length < 1 || isRulesLoading) {
      return (
        <Wrap>
          <Loading />
        </Wrap>
      );
    }

    const fromAssociateState = this.props.location!.state as any;

    return (
      <Wrap>
        <Helmet title="Add Action" />
        <CreateAction
          onSave={requestSave}
          rules={rules}
          sites={sites}
          isPending={isPending}
          submitError={submitError}
          fromAssociate={fromAssociateState}
          urlHistory={urlHistory}
          userAccess={userAccess!}
          userGroups={userGroups!}
          token={token}
        />
      </Wrap>
    );
  }
}

const connected = connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateActionScene);
export { connected as CreateActionScene };
